import { FC, useCallback } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Image from "next/legacy/image";
import eyesImage from '@/public/assets/icons/search-no-results.svg';
import starsIcon from '@/public/assets/icons/stars.svg';
import { useRouter } from 'next/router';

const SearchReturnedNoResults: FC = () => {
	const theme = useTheme();
	const router = useRouter();
	const goHome = useCallback(async () => router.push('/'), [router]);

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
				gap: '35px',
			}}
		>
			<Box sx={{ position: 'relative', width: '88px', height: '88px' }}>
				<Image src={eyesImage} alt={'eyes'} layout={'fill'} />
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '32px',
				}}
			>
				<Typography
					sx={{
						fontFamily: 'Integral CF',
						fontWeight: 500,
						fontSize: '22px',
						lineHeight: 1.2,
						fontStyle: 'italic',
						color: theme.palette.primary.dark,
					}}
				>
					No results found.
				</Typography>
				<Typography
					sx={{
						fontFamily: 'Integral CF',
						fontWeight: 500,
						fontSize: '14px',
						lineHeight: 1.2,
						fontStyle: 'italic',
						color: theme.palette.primary.dark,
					}}
				>
					Try tweaking filters for better results!
				</Typography>
			</Box>
		</Box>
	);
};

export default SearchReturnedNoResults;
